<template>
    <div class="letter">
        <div v-for="(item, index) in onlineDetailData.question" :key="index" class="remarks">
            <History
                :title="`问题${index + 1}：`"
                :content="item.remark"
                :tabaData="item.edit"
            />
            <div>
                <!-- 添加附件 -->
                <div>
                    <span v-for="(item, index) in item.file" :key="index">
                        <a target='_blank' v-if="item.fileList.length" type="text" :href="`${$utils.toOss(item.fileList[0].fileUrl)}`">{{ item.name }}</a>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import History from '../../C/History'
    export default {
        components: {
            History
        },
        props: {
            // 接收的数据
            onlineDetailData: {
                type: Object,
                default: () => {}
            }
        },
        data() {
            return {

            }
        },
    }
</script>

<style lang="less" scoped>
.letter{
    a{
    color: #409eff;
    font-size: 12px;
    margin-right: 20px;
}
    .remarks{
        // height: 50px;
        margin-bottom: 20px;
        >div{

        }
    }
}

</style>
